<template>
    <div>
        <header>
            <!-- <div class="title">{{title}}</div> -->
            <h1>Smart Flight For DJI - 支持页面</h1>
        </header>
        <section style="display: flex;flex-direction: column;align-items: center;">
            <div class="content">
                
                <p class="subtitle">感谢您使用我们的应用，我们提供全天候使用支持</p>
                <h2>📩 联系我们</h2>
                <p>如遇到使用问题、功能建议或故障反馈，请通过邮箱联系：1490239281@qq.com</p>
                
                <div>应用支持：</div>
                <div>1.航点规划和飞行</div>
                <div>2.航线保存和加载</div>
                <div>3.倾斜摄影</div>
             </div>

             <div class="footer" style="margin-top: 100px;">
                © 2026 Smart Flight For DJI. All rights reserved.
            </div>
        </section>

    </div>
   
</template>

<script>
export default {
    data() {
        return {
            title:"Smart Flight 隐私说明",
            content:""
        }
    }    
}
</script>

<style scoped>
.title {
    font-size: 20px;
    font-weight: 800;
    height: 40px;
    line-height: 40px;
}
.content {
    padding:0 16px;
    text-align: left;
}
div {
    margin-bottom: 5px;
}
</style>


// WEBPACK FOOTER //
// src/pages/SupportedUrl.vue